(async () => {
  const el = document.getElementById('lpu-list-content')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/lpu/index.vue'),
    },
  ]

  await clientRender({ components })
})()
